import styled from 'styled-components';
import Image from '@stencil/image';

export const HotelImageWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
  `,
);

export const HotelGalleryImage = styled(Image)(
  props => `
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.base};
    object-fit: fill;
    width:25.8rem;
    margin-bottom: ${props.theme.spacing.large};
    height: 14.5rem;
    margin: 0;
  `,
);
